<!-- Единая информационная подсказка для коротких пояснений в интерфейсе -->
<template>
  <BaseTooltip
    :text="displayText"
    :position="position"
    :max-width="maxWidth"
    tabindex="0"
    :aria-label="variant === 'icon' ? accessibleLabel : undefined"
  >
    <span
      :class="tooltipClasses"
    >
      <slot v-if="variant === 'text'" />
      <svg
        v-else
        class="base-info-tooltip__icon"
        viewBox="0 0 24 24"
        fill="none"
        width="16"
        height="16"
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="1.5"
        />
        <path
          d="M12 8v1M12 11v5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </span>
    <template v-if="variant === 'icon' && $slots.default" #content>
      <slot />
    </template>
  </BaseTooltip>
</template>

<script>
import { fieldInfoByKey } from "@/config/fieldInfo";

export default {
  name: "BaseInfoTooltip",

  props: {
    text: {
      type: String,
      default: "",
    },
    // Ключ из src/config/fieldInfo.js для единого текста подсказки
    infoKey: {
      type: String,
      default: "",
    },
    ariaLabel: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      default: "bottom",
    },
    maxWidth: {
      type: [Number, String],
      default: 320,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    // icon: отдельная иконка i для форм
    // text: tooltip на самом тексте label для плотных read-only карточек
    variant: {
      type: String,
      default: "icon",
      validator: (value) => ["icon", "text"].includes(value),
    },
  },

  computed: {
    displayText() {
      return this.text || fieldInfoByKey(this.infoKey);
    },
    accessibleLabel() {
      return this.ariaLabel || this.displayText || "Пояснение";
    },
    tooltipClasses() {
      return [
        "base-info-tooltip",
        `base-info-tooltip--${this.variant}`,
        {
          "base-info-tooltip--filled": this.filled,
        },
      ];
    },
  },
};
</script>

<style scoped>
.base-info-tooltip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  cursor: help;
}

.base-info-tooltip:hover,
.base-info-tooltip:focus {
  color: #6b7280;
  outline: none;
}

.base-info-tooltip--filled {
  color: #9bbfa9;
}

.base-info-tooltip--text {
  max-width: 100%;
  color: #6b7280;
  border-bottom: 1px dotted rgba(107, 114, 128, 0.45);
}

.base-info-tooltip--text.base-info-tooltip--filled {
  color: #6b7280;
  border-bottom-color: rgba(107, 114, 128, 0.45);
}

.base-info-tooltip--text:hover,
.base-info-tooltip--text:focus {
  color: #374151;
  border-bottom-color: rgba(55, 65, 81, 0.55);
}

.base-info-tooltip__icon {
  display: block;
  flex-shrink: 0;
}
</style>
